import { render, staticRenderFns } from "./BdCuw.vue?vue&type=template&id=3daa7c92&scoped=true&"
import script from "./BdCuw.vue?vue&type=script&lang=js&"
export * from "./BdCuw.vue?vue&type=script&lang=js&"
import style0 from "./BdCuw.vue?vue&type=style&index=0&id=3daa7c92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3daa7c92",
  null
  
)

export default component.exports